// 校验手机号正则
export const phoneNumberReg = /^1[3-9]\d{9}$/;

// 校验账号正则（手机号或邮箱，邮箱后续支持）
export const accountReg = /(^1[3-9]\d{9}$)|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)/;

export const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// 校验中文正则
export const chineseReg = /^[\u4E00-\u9FFF]+$/g;

// 校验密码正则
export const passwordReg = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,16}$/;